import {
  DOCUMENT_LIST, 
  DOCUMENT_LIST_SUCCESS, 
  DOCUMENT_LIST_ERROR,
  DOCUMENT_SEARCH_SET, 
  DOCUMENT_SEARCH_CHANGE, 
  DOCUMENT_PAGE_SET,
  DOCUMENT_SEARCH_DOCUMENT_TYPE,
  DOCUMENT_SEARCH_DOCUMENT_TYPE_SUCCESS,
  DOCUMENT_SEARCH_DOCUMENT_TYPE_ERROR,
  DOCUMENT_ADD_SET,
  DOCUMENT_ADD_MODAL_SET,
  DOCUMENT_ADD,
  DOCUMENT_ADD_SUCCESS,
  DOCUMENT_ADD_ERROR,
  DOCUMENT_ADD_CHANGE,
  DOCUMENT_DETAIL,
  DOCUMENT_DETAIL_SUCCESS,
  DOCUMENT_DETAIL_ERROR,
  DOCUMENT_VIEW_MODAL_SET,
  DOCUMENT_EDIT_CHANGE,
  DOCUMENT_EDIT_MODAL_SET,
  DOCUMENT_UPDATE,
  DOCUMENT_UPDATE_SUCCESS,
  DOCUMENT_UPDATE_ERROR,
  DOCUMENT_VIEW_TAB_SET,
  DOCUMENT_UPLOAD_SET,
  DOCUMENT_UPLOAD_SET_SUCCESS,
  DOCUMENT_UPLOAD_SET_ERROR,
  DOCUMENT_UPLOAD_RESET
} from '../../actions';
 
const INIT_STATE = {
  loading: true,
  file: [],
  list: {
    header:{
      name: 'code',
      order:'sorted-asc'
    },
    page:{
      current: 1,
      rows: 10
    }
  },
  add: {
      data: {
        new:{ id_document_type: null, document_type: null, name: '', url_link: '', url_file: '', original_file_name: '', file_name: '' }
      },
      modal: false,
      loading: false,
      message: '',
      url: '',
      type: ''
  },
  error: false,
  search:{
    modal: false,
    init:true,
    data:{
      document_type: false
    },
    value:{
      document_type: false,
    },
    document_type:{
      loading: true,
      list:[],
      message: ''
    }
  },
  detail: {
    data: [],
    tab: 'general',
    loading: true,
  },
  view: {
    loading: true,
    data: [],
    tab: 'general',
    modal: false,
    log: {
      data: [],
      loading: false,
    },
  },
  edit: {
    loading: true,
    data: {
        new: [],
        old: []
    },
    list: {
        status: {
            data: [],
            loading: false,
        }
    },
    modal: false,
    update: {
        loading: false,
        response: '',
        message: ''
    }
  }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case DOCUMENT_LIST:
      return {
        ...state,
        loading: true,
        list: {
          ...state.list
        }
        
      }
    case DOCUMENT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: {
          ...state.list,
          ...action.payload
        } 
      }
    case DOCUMENT_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: true
      }
    case DOCUMENT_SEARCH_SET:
      return {
        ...state,
        search:{
          ...state.search,
          data: action.payload,
        }
      }
    case DOCUMENT_SEARCH_CHANGE:
      return {
        ...state,
        search:{
          ...state.search,
          value: action.payload,
        }
      }
    case DOCUMENT_PAGE_SET:
      return {
        ...state,
        list: {
          ...state.list,
          page: {
            ...state.list.page,
            ... action.payload,
          }
        },
        log: []
      }
    case DOCUMENT_SEARCH_DOCUMENT_TYPE:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          document_type:{
            ...state.search.document_type,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case DOCUMENT_SEARCH_DOCUMENT_TYPE_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          document_type:{
            ...state.search.document_type,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case DOCUMENT_SEARCH_DOCUMENT_TYPE_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          document_type:{
            ...state.search.document_type,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case DOCUMENT_ADD_CHANGE:
      return {
        ...state,
        add: {
          ...state.add,
          data: {
            ...state.add.data,
            new: {
              ...state.add.data.new,
              ...action.payload
            }
          }
        }
      }
    case DOCUMENT_ADD_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: action.payload
        }
      }
    case DOCUMENT_ADD_MODAL_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: { 
            ...state.add.data,
            new: { id_document_type: null, document_type: null, name: '', url_link: '', url_file: '', original_file_name: '', file_name: '' }
          },
          modal: action.payload
        }
      }
    case DOCUMENT_ADD:
      return {
        ...state,
        add: {
          ...state.add, 
          loading: true
        }
      }
    case DOCUMENT_ADD_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          modal: false,
          loading: false,
          message: action.payload.message,
          id: action.payload.id
        }
      }
    case DOCUMENT_ADD_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          loading: false,
          message: action.payload.message
        }
      }
    case DOCUMENT_DETAIL:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
          data: []
        }
      }
    case DOCUMENT_DETAIL_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload
        },
        edit: {
          ...state.edit,
          loading: false,
          data: {
            new: action.payload,
            old: action.payload
          }
        }
      }
    case DOCUMENT_DETAIL_ERROR:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: []
        }
      }
    case DOCUMENT_VIEW_MODAL_SET:
      return {
        ...state,
        view: {
          ...state.view,
          modal: action.payload
        }
      }
    case DOCUMENT_EDIT_MODAL_SET:
      return {
        ...state,
        edit: {
          ...state.edit,
          modal: action.payload
        }
      }
    case DOCUMENT_EDIT_CHANGE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              ...action.payload
            }
          }
        }
      }
    case DOCUMENT_UPDATE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            ...action.payload,
          },
          update: {
            ...state.update,
            loading: true,
            response: '',
            message: ''
          }
        }
      }
    case DOCUMENT_UPDATE_SUCCESS:
      return {
        ...state,
        edit: { 
          ...state.edit,
          modal: false,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              update_reason: ''
            },
            old: {
              ...state.edit.data.new,
              update_reason: ''
            }
          },
          update: {
            ...state.update,
            loading: false,
            response: 'success',
            message: action.payload
          }
        },
        view: {
          ...state.view,
          modal: false
        }
      }
    case DOCUMENT_UPDATE_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          update: {
            ...state.update,
            loading: false,
            response: 'error',
            message: action.payload
          }
        }
      }
    case DOCUMENT_VIEW_TAB_SET:
      return {
        ...state,
        view: {
          ...state.view,
          tab: action.payload
        }
      }
    case DOCUMENT_UPLOAD_SET:
      return { ...state };
    case DOCUMENT_UPLOAD_SET_SUCCESS:
      return {
        ...state,
        file: [...state.file, action.payload]
      };
    case DOCUMENT_UPLOAD_SET_ERROR:
      return { 
        ...state,
        file: [...state.file, action.payload]
      };
    case DOCUMENT_UPLOAD_RESET:
      return {
        ...state,
        file: []
      };
    default:
      return { ...state };
    }

};